import { useMemo } from "react";

export function isDesktop() {
  console.log("isDesktop() called - checking conditions...");

  // First priority: Development override (most reliable in dev mode)
  const hasForceFlag = import.meta.env.VITE_FORCE_DESKTOP_MODE === "true";
  console.log("Development override (VITE_FORCE_DESKTOP_MODE):", {
    value: import.meta.env.VITE_FORCE_DESKTOP_MODE,
    result: hasForceFlag,
  });
  if (hasForceFlag) {
    console.log(
      "✅ isDesktop() = true (development override - simulating desktop)",
    );
    return true;
  }

  // Second priority: Check if we're actually in a Neutralino environment
  const hasNeutralinoGlobals =
    typeof window !== "undefined" &&
    Object.keys(window).some((key) => key.startsWith("NL_"));
  const hasNeutralinoObject = window?.Neutralino;
  const isNeutralinoUserAgent =
    typeof navigator !== "undefined" &&
    navigator.userAgent &&
    navigator.userAgent.includes("Neutralino");

  console.log("Neutralino environment check:", {
    hasGlobals: hasNeutralinoGlobals,
    globalsCount: hasNeutralinoGlobals
      ? Object.keys(window).filter((key) => key.startsWith("NL_")).length
      : 0,
    hasNeutralinoObject: !!hasNeutralinoObject,
    isNeutralinoUserAgent,
    userAgent:
      typeof navigator !== "undefined" ? navigator.userAgent : "undefined",
  });

  if (hasNeutralinoGlobals || hasNeutralinoObject || isNeutralinoUserAgent) {
    console.log("✅ isDesktop() = true (Neutralino environment detected)");
    return true;
  }

  // Third priority: Check for build-time desktop target flag
  const hasBuildFlag = typeof __IS_DESKTOP__ !== "undefined" && __IS_DESKTOP__;
  console.log("Build-time flag (__IS_DESKTOP__):", {
    defined: typeof __IS_DESKTOP__ !== "undefined",
    value: typeof __IS_DESKTOP__ !== "undefined" ? __IS_DESKTOP__ : "undefined",
    result: hasBuildFlag,
  });
  if (hasBuildFlag) {
    console.log("✅ isDesktop() = true (build target is desktop)");
    return true;
  }

  // Default: This is a web environment
  console.log("❌ isDesktop() = false (web environment)");
  return false;
}

export function useIsDesktop() {
  return useMemo(() => {
    return isDesktop();
  }, []);
}
